const metaConfigId = process.env.REACT_APP_META_CONFIG_ID;

export function launchWhatsAppCoexistence(setDebugToken, customer, onSuccess, configId = null) {
  console.log('🚀 launchWhatsAppCoexistence CALLED');
  console.log('Customer data:', customer);
  console.log('onSuccess callback:', typeof onSuccess);
  
  // Use provided configId or fall back to env variable
  const finalConfigId = configId || metaConfigId;
  console.log('Config ID:', finalConfigId);
  
  // Store the access token for use in the event callback
  let userAccessToken = null;
  
  /**
   * Prepare customer data for setup (optional pre-fill)
   */
  let site = customer?.site ?? '';
  if (site && !site.includes('https://') && !site.includes('http://')) {
    site = 'http://' + site;
  }
  
  let phone_code = 55;
  let phone_number = customer?.phone ?? '';
  
  if (phone_number) {
    let _code = phone_number.substr(0, 3);
    if (_code?.includes('+')) {
      phone_code = _code.substr(1, 3);
      phone_number = phone_number.substr(3, phone_number.length);
    } else if (_code?.includes('55')) {
      phone_number = phone_number.substr(2, phone_number.length);
    }
  }
  
  // Register callback for Embedded Signup events BEFORE launching the flow
  // This ensures the event listener is ready
  window.FB.Event.subscribe('wa.embedded_signup', (response) => {
    console.log('Embedded Signup event:', response);
    
    // For coexistence flow, the event is FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING
    // According to Meta docs: https://developers.facebook.com/docs/whatsapp/embedded-signup/custom-flows/onboarding-business-app-users/
    if (response.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING' && response.type === 'WA_EMBEDDED_SIGNUP') {
      console.log('Coexistence onboarding completed:', response.data);
      // The response.data contains: phone_number_id, waba_id, etc
      if (onSuccess && response.data) {
        // Combine event data with access token from login
        const enrichedData = {
          ...response.data,
          access_token: userAccessToken || response.data.access_token
        };
        onSuccess(enrichedData);
      }
    }
  });

  // Define scope for WhatsApp Business API Coexistence
  const scope = 'business_management,whatsapp_business_management,whatsapp_business_messaging';

  // Callback function for Embedded Signup events
  const fbLoginCallback = (response) => {
    console.log('Facebook login response:', response);
    console.log('Login status:', response.status);
    
    if (response.authResponse) {
      const accessToken = response.authResponse.accessToken;
      console.log('Access token obtained successfully');
      
      // Store the access token for use in the event callback
      userAccessToken = accessToken;
      
      // Pass token to the callback (though it won't trigger useEffect in coexistence flow)
      setDebugToken(accessToken);
      
      // After successful login, the Embedded Signup modal should open automatically
      // If it doesn't, the user may need to allow popups
      console.log('Waiting for Embedded Signup modal to open...');
      console.log('User should now see the WhatsApp Business App onboarding flow');
    } else {
      console.error('Facebook login failed:', response);
      console.error('Response status:', response.status);
      setDebugToken('ERROR');
    }
  };

  // Launch Facebook login with Coexistence setup
  // According to Meta documentation: https://developers.facebook.com/docs/whatsapp/embedded-signup/custom-flows/onboarding-business-app-users/
  console.log('🔵 Checking Facebook SDK...');
  console.log('window.FB exists:', !!window.FB);
  console.log('window.FB.login exists:', !!(window.FB && window.FB.login));
  
  if (!window.FB || !window.FB.login) {
    console.error('❌ Facebook SDK not loaded!');
    setDebugToken('ERROR');
    return;
  }
  
  console.log('✅ Facebook SDK loaded, calling FB.login...');
  console.log('Scope:', scope);
  
  // Extras config based on the Facebook reference URL structure
  const extrasConfig = {
    sessionInfoVersion: '3',
    version: 'v3',
    featureType: 'whatsapp_business_app_onboarding',
    partner_data: 'null',
    is_hosted_es: true,
  };
  
  console.log('Extras config:', JSON.stringify(extrasConfig, null, 2));
  
  // Build login config
  const loginConfig = {
    scope: scope,
    return_scopes: true,
    auth_type: 'rerequest',
    response_type: 'code',
    override_default_response_type: true,
    display: 'popup', // Mantém a experiência em popup da Poli
    extras: extrasConfig,
  };
  
  // Add config_id if available
  if (finalConfigId) {
    loginConfig.config_id = finalConfigId;
    console.log('✅ Using config_id:', finalConfigId);
  } else {
    console.warn('⚠️ No config_id provided - coexistence may not work properly!');
    console.warn('💡 Set REACT_APP_META_CONFIG_ID in your .env file');
  }
  
  console.log('Full FB.login config:', JSON.stringify(loginConfig, null, 2));
  
  window.FB.login(fbLoginCallback, loginConfig);
}
